module.exports = __webpack_public_path__ + "img/6.ddfb74cf.png";